// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, doc, collection, query, where, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBf_BJL6JyGnIZS9cFoEWGngp6aQpkxfUo",
  authDomain: "monterrave-1f76f.firebaseapp.com",
  databaseURL: "https://monterrave-1f76f-default-rtdb.firebaseio.com",
  projectId: "monterrave-1f76f",
  storageBucket: "monterrave-1f76f.firebasestorage.app",
  messagingSenderId: "642157015491",
  appId: "1:642157015491:web:d998cb480f031d59078d76",
  measurementId: "G-0Y7LN6974B"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const firestore = getFirestore(app);

/*
users/{uid} = {
  roles = {"Scanner", "User", "Admin", "RP"},
  displayName = ""
}

raves/{id} = {
  fecha = "",
  lugar = ""
}

*/

export function getUserDoc(uid) {
  return doc(firestore, `users/${uid}`);
}

export function getUserTicketQuery(raveId, uid, ticketTypeId) {
  return query(collection(firestore, `raves/${raveId}/ticketTypes/${ticketTypeId}/tickets`), where("uid", "==", uid));
}

export function useQuery(q) {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const fetchDocs = async () => {
        const snapshot = await getDocs(q);
        return snapshot.docs;
      }
      fetchDocs().then(setTickets);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setError(error);
    }

  }, [q]);
  
  return [tickets, loading, error];
}

